import React, { useMemo } from 'react';
import Modifier from './Modifier';
import useHelpers from '../../hooks/context/useHelpers';
import { computeModifierTree } from '../../services/helpers/OrderMath';

export default function OrderLineItem({ lineItem, isLastItem }) {
  const { formatCurrency } = useHelpers();

  const modifierTree = useMemo(() => computeModifierTree(lineItem), [lineItem]);
  const renderModifier = (node, isNested = false) => (
    <section key={node.id} className="pl-md">
      <Modifier name={node.name} quantity={node.quantity} price={node.price} isNested={isNested} />
      {node.children.map((child) => renderModifier(child, true))}
    </section>
  );

  return (
    <>
      <div className="flex mt-md">
        <div className="w-1/12">
          <div className="website-text font-semibold">{lineItem.quantity}x</div>
        </div>
        <div className="w-9/12">
          <div className="website-text font-semibold break-words">{lineItem.product.name}</div>
        </div>
        <div className="w-2/12">
          <div className="text-right website-text">{formatCurrency(lineItem.item_price)}</div>
        </div>
      </div>
      {modifierTree.length > 0 && (
        <div className="flex mt-2xs">
          <div className="w-1/12" />
          <div className="w-11/12">{modifierTree.map((rootModifier) => renderModifier(rootModifier))}</div>
        </div>
      )}
      {lineItem.note && (
        <div className="flex mt-2xs">
          <div className="w-1/12" />
          <div className="w-11/12">
            <div className="website-text italic">{lineItem.note}</div>
          </div>
        </div>
      )}
      {!isLastItem && <hr className="w-full mt-2 mb-0 bg-gray-200 h-px" />}
    </>
  );
}
